import { useEffect, useState } from 'react';
import PageLoader from '../../../../../component/PageLoader';
import SendEmail from '../../../../components/SendEmail';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchPaymentReceivedDetails, sendEmail } from '../../../../../services/payments_received';

const PaymentReceivedSendEmail = () => {
	const params = useParams();
	const { id } = params;
	const { userInfo } = useSelector((state) => state);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();
	const [toEmails, setToEmails] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [prDetails, setInvoiceDetails] = useState(null);
	const [emailFormData, setEmailFormData] = useState({
		from: '',
		to: [],
		subject: '',
		body: '',
		isAttachment: true,
	});

	async function handleSend(formData) {
		try {
			await sendEmail(id, formData);
			toast.success('Email Sent Successfully.');
			navigate(`/user/${suburl}/payments-received`);
		} catch (error) {
			throw error;
		}
	}

	function handleClose() {
		navigate(`/user/${suburl}/payments-received`);
	}

	async function handleFetchPRDetails() {
		try {
			setIsLoading(true);
			const { payment_receive } = await fetchPaymentReceivedDetails({ ids: [Number(id)] });
			setInvoiceDetails(payment_receive);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {
		if (id) {
			handleFetchPRDetails();
		}
	}, [id]);

	useEffect(() => {
		if (prDetails && userInfo) {
			const { payment_receive_number, customer } = prDetails;

			var customerEmailList = [];
			var customerToSendEmailList = [];
			if (customer?.email) {
				customerEmailList.push(customer.email);
				customerToSendEmailList.push(customer.email);
			}
			setEmailFormData((prev) => ({
				...prev,
				to: customerToSendEmailList,
				from: `${userInfo?.userInfo?.data?.first_name} ${userInfo?.userInfo?.data?.last_name}`,
				subject: `Payments Received from ${userInfo?.userInfo?.data?.first_name + ' ' + userInfo?.userInfo?.data?.last_name} (Payment #: ${payment_receive_number})`,
			}));
			setToEmails(customerEmailList);
		}
	}, [prDetails, userInfo]);

	if (isLoading) {
		return <PageLoader />;
	}

	return (
		<SendEmail
			pdfName="Payments Received"
			pdfId={`${prDetails?.payment_receive_number}`}
			toEmails={toEmails}
			formData={emailFormData}
			handleSend={handleSend}
			handleClose={handleClose}
			isDropdownListShow={false}
		/>
	);
};

export default PaymentReceivedSendEmail;
